export default "__VITE_ASSET__QxOUQKsQ__"